import { render, staticRenderFns } from "./Kunden.vue?vue&type=template&id=487bda9e&"
import script from "./Kunden.vue?vue&type=script&lang=js&"
export * from "./Kunden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports